import React from "react";

const Video = ({ title, src, framed = true, className = "", containerClassName = "" }) => {
  const iframe = (
    <iframe
      className={`mx-auto aspect-video w-full ${className}`}
      src={src}
      title={title || "YouTube video player"}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerPolicy="strict-origin-when-cross-origin"
      allowFullScreen
    ></iframe>
  );

  if (!framed) return iframe;

  return (
    <div className={`mx-auto mt-4 divide-gray-100 rounded-md border border-gray-200 p-4 ${containerClassName}`}>
      {title && <span className="truncate font-medium">{title}</span>}
      {iframe}
    </div>
  );
};

export default Video;
